<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <card>
            <template slot="header">
              <div class="row">
                <div class="col-md-6">
                  <h4 class="card-title">Riepilogo compensi</h4>
                  <button class="btnPrint" v-on:click="generatePDF()"><i class="fa fa-print"></i> Stampa tutti</button> 
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="control-label">
                      Mese
                    </label>
                    <date-picker
                            class="riepilogo-mensile-date-picker"
                            type="month"
                            lang="it"
                            :clearable=false
                            value-type="date"
                            :format="monthFormat"
                            label="Giorno"
                            v-model="giorno">
                    </date-picker>
                  </div>
                </div>
              </div>
            </template>
            <p v-if="loading" class="card-category">
              <center>{{ loadingText }}</center>
            </p>
            <div class="row" v-if="!loading">
              <div class="table-ore-lavoro-mensili" :style="{'max-width':'100%','max-height':Math.max(200,window.height-200)+'px'}">
                <vue-scrolling-table class="table" deadAreaColor="#FFF">
                  <template slot="thead">
                    <tr>
                      <th style="width:200px !important;min-width:200px !important;max-width:200px !important;"></th>
                      <th style="width:120px !important;min-width:120px !important;max-width:120px !important;" v-for="lav in lavorazioni"><button class="btnPrint" v-on:click="generatePDFLavorazioni(lav)"><i class="fa fa-print"></i></button><br/> {{ lav.lavorazione }}</th>
                      <th style="width:120px !important;min-width:120px !important;max-width:120px !important;"><b>Totale</b></th>
                      <th style="width:120px !important;min-width:120px !important;max-width:120px !important;"><b>Paga oraria</b></th>
                      <th style="width:120px !important;min-width:120px !important;max-width:120px !important;"><b>Acconto</b></th>
                      <th style="width:140px !important;min-width:140px !important;max-width:140px !important;"><b>Compenso</b></th>
                    </tr>
                  </template>
                  <template slot="tbody">
                    <tr v-for="dip in dipendenti">
                      <td style="width:200px !important;min-width:200px !important;max-width:200px !important;"><button class="btnPrint" v-on:click="generatePDF(dip)"><i class="fa fa-print"></i></button> {{ dip.nome }} {{ dip.cognome }}</td>
                      <td style="width:120px !important;min-width:120px !important;max-width:120px !important;" v-for="lav in lavorazioni" class="ore-lavoro-mensili">
                        {{ getTotaleDipLav(dip.id, lav.id) }}
                      </td>
                      <td style="width:120px !important;min-width:120px !important;max-width:120px !important;" class="ore-lavoro-mensili-totali">{{ getTotaleDipendente(dip.id) }}</td>
                      <td style="width:120px !important;min-width:120px !important;max-width:120px !important;" class="ore-lavoro-mensili-paga-oraria">{{ numberToString(dip.paga_oraria, 2) }} €/h</td>
                      <td style="width:120px !important;min-width:120px !important;max-width:120px !important;" class="ore-lavoro-mensili-totali">{{ getAccontiString(dip) }}</td>
                      <td style="width:140px !important;min-width:140px !important;max-width:140px !important;" class="ore-lavoro-mensili-totali">{{ getCompensoDipendenteString(dip) }}</td>
                    </tr>
                    <tr>
                      <td style="width:160px !important;min-width:160px !important;max-width:160px !important;"><b>Totale</b></td>
                      <td style="width:120px !important;min-width:120px !important;max-width:120px !important;" v-for="lav in lavorazioni" class="ore-lavoro-mensili-totali">{{ getTotaleLavorazione(lav.id) }}</td>
                      <td style="width:120px !important;min-width:120px !important;max-width:120px !important;" class="ore-lavoro-mensili-totali">{{ getTotaleGenerale() }}</td>
                      <td style="width:120px !important;min-width:120px !important;max-width:120px !important;" class="ore-lavoro-mensili-totali"></td>
                      <td style="width:120px !important;min-width:120px !important;max-width:120px !important;" class="ore-lavoro-mensili-totali"></td>
                      <td style="width:140px !important;min-width:140px !important;max-width:140px !important;" class="ore-lavoro-mensili-totali">{{ getTotaleCompensi() }}</td>
                    </tr>
                  </template>
                </vue-scrolling-table>
              </div>
            </div>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Card from 'src/components/UIComponents/Cards/Card.vue'
  import VueScrollingTable from 'vue-scrolling-table'
  
  export default {
    components: {
      Card,
      VueScrollingTable
    },
    data () {
      return {
        countCaricaGiorno: 0,
        erroreSalvataggio: '',
        loading: true,
        loadingText: 'Caricamento in corso...',
        backendPath: 'ore-lavoro/report-mese',
        giorno: null,
        dipendenti: [],
        lavorazioni: [],
        lavoro: [],
        acconti: [],
        monthFormat: {
          stringify: (date) => {
            if (date instanceof Date) {
              var tzoffset = date.getTimezoneOffset() * 60000
              var strDate = (new Date(date.getTime() - tzoffset)).toISOString().substr(0, 19).replace('T', ' ')
              var anno = strDate.substr(0, 4)
              var mese = parseInt(strDate.substr(5, 2)) - 1
              var arrayMesi = ['Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno', 'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre']
              return arrayMesi[mese] + ' ' + anno
            }
            return ''
          },
          parse: (value) => {
            if (typeof value === 'string') {
              var mmaa = value.trim().split(' ')
              if (mmaa.length !== 2) {
                return null
              }
              var anno = mmaa[1]
              var arrayMesi = ['GENNAIO', 'FEBBRAIO', 'MARZO', 'APRILE', 'MAGGIO', 'GIUGNO', 'LUGLIO', 'AGOSTO', 'SETTEMBRE', 'OTTOBRE', 'NOVEMBRE', 'DICEMBRE']
              var meseMenoUno = arrayMesi.indexOf(mmaa[0].toUpperCase())
              if (meseMenoUno !== -1) {
                var date = new Date()
                date.setMonth(meseMenoUno)
                date.setYear(anno)
                return date
              }
            }
            return null
          }
        },
        window: {
          width: 0,
          height: 0
        }
      }
    },
    created () {
      window.addEventListener('resize', this.handleResize)
      this.handleResize()
    },
    destroyed () {
      window.removeEventListener('resize', this.handleResize)
    },
    mounted () {
      var me = this
      me.$data.giorno = new Date()
    },
    watch: {
      giorno (value) {
        var me = this
        if (value instanceof Date && value.getTime()) {
          var mese = this.dateToString(value).substr(0, 7)
          me.caricaGiorno(mese)
        } else {
          me.resettaData()
        }
      }
    },
    methods: {
      handleResize () {
        this.window.width = window.innerWidth
        this.window.height = window.innerHeight
      },
      resettaData () {
        var me = this
        me.$data.loading = true
        me.$data.loadingText = 'Caricamento in corso...'
        me.$data.backendPath = 'ore-lavoro/report-mese'
        me.$data.dipendenti = []
        me.$data.lavorazioni = []
        me.$data.lavoro = []
      },
      caricaGiorno: function (giorno) {
        var me = this
        me.resettaData()
        var countCaricaGiorno = ++me.$data.countCaricaGiorno
        if (!giorno) {
          return
        }
        var url = process.env.API_URL + me.$data.backendPath + '/' + giorno
        var method = 'GET'
        var params = {}
        var successFn = function (data) {
          if (countCaricaGiorno !== me.$data.countCaricaGiorno) {
            return
          }
          var lavoro = {}
          for (var d in data.dipendenti) {
            var idD = data.dipendenti[d].id
            lavoro[idD] = {}
            for (var l in data.lavorazioni) {
              var idL = data.lavorazioni[l].id
              if (data.minuti[idD] && data.minuti[idD][idL]) {
                lavoro[idD][idL] = data.minuti[idD][idL]
              }
            }
          }
          me.$data.loading = false
          me.$data.dipendenti = data.dipendenti
          me.$data.lavorazioni = data.lavorazioni
          me.$data.lavoro = lavoro
          me.$data.acconti = data.acconti
        }
        var errorFn = function (message) {
          if (typeof message === 'undefined') {
            message = 'Network Error'
          }
          me.$data.loadingText = 'Errore: ' + message
          me.ajaxErrorFn(message)
        }
        this.ajax(url, method, params, successFn, errorFn)
      },
      getTotaleLavorazione (idLav) {
        var lavoro = this.$data.lavoro
        var tot = 0
        for (var idDip in lavoro) {
          if (lavoro[idDip][idLav]) {
            tot += parseInt(lavoro[idDip][idLav])
          }
        }
        var mTot = tot % 60
        var hTot = (tot - mTot) / 60
        if (mTot < 10) {
          mTot = '0' + mTot
        }
        return hTot + ':' + mTot
      },
      getTotaleDipendente (idDip) {
        var lavoro = this.$data.lavoro
        var tot = 0
        for (var idLav in lavoro[idDip]) {
          if (lavoro[idDip][idLav]) {
            tot += parseInt(lavoro[idDip][idLav])
          }
        }
        var mTot = tot % 60
        var hTot = (tot - mTot) / 60
        if (mTot < 10) {
          mTot = '0' + mTot
        }
        return hTot + ':' + mTot
      },
      getCompensoDipendenteString (dip) {
        var compenso = this.getCompensoDipendente(dip)
        if (compenso === null) {
          return ''
        }
        return this.numberToString(compenso, 2) + ' €'
      },
      getCompensoDipendente (dip) {
        var idDip = dip.id
        var lavoro = this.$data.lavoro
        var totMinuti = 0
        var compenso = 0
        for (var idLav in lavoro[idDip]) {
          if (lavoro[idDip][idLav]) {
            totMinuti += parseInt(lavoro[idDip][idLav])
          }
        }
        compenso = Math.round(100 * totMinuti * dip.paga_oraria / 60) / 100
        compenso -= this.$data.acconti[dip.id] || 0
        if (!compenso) {
          return null
        }
        return compenso
      },
      getTotaleCompensi () {
        var totale = 0
        var dipendenti = this.$data.dipendenti
        for (var idDip in dipendenti) {
          var compenso = this.getCompensoDipendente(dipendenti[idDip])
          if (compenso !== null) {
            totale += compenso
          }
        }
        return this.numberToString(totale, 2) + ' €'
      },
      getTotaleDipLav (idDip, idLav) {
        var lavoro = this.$data.lavoro
        var tot = 0
        if (lavoro[idDip] && lavoro[idDip][idLav]) {
          tot = parseInt(lavoro[idDip][idLav])
        }
        var mTot = tot % 60
        var hTot = (tot - mTot) / 60
        if (mTot < 10) {
          mTot = '0' + mTot
        }
        return hTot + ':' + mTot
      },
      getTotaleGenerale () {
        var lavoro = this.$data.lavoro
        var tot = 0
        for (var idDip in lavoro) {
          for (var idLav in lavoro[idDip]) {
            if (lavoro[idDip][idLav]) {
              tot += parseInt(lavoro[idDip][idLav])
            }
          }
        }
        var mTot = tot % 60
        var hTot = (tot - mTot) / 60
        if (mTot < 10) {
          mTot = '0' + mTot
        }
        return hTot + ':' + mTot
      },
      getAccontiString (dip) {
        var acconto = this.$data.acconti[dip.id]
        if (!acconto) {
          return ''
        }
        return this.numberToString(parseFloat(acconto), 2) + ' €'
      },
      generatePDF (dip) {
        var dipId = typeof dip !== 'undefined' ? dip.id : ''
        var anno = this.$data.giorno.getFullYear()
        var mese = this.$data.giorno.getMonth() + 1
        if (mese < 10) {
          mese = '0' + mese
        }
        window.open('https://cortassa.ideadinamica.it/api/pdf/compensi/?dip=' + dipId + '&date=' + anno + '-' + mese, '_blank')
        /* window.open('https://localhost/dinamica/cortassa/api/pdf/compensi/?dip=' + dipId + '&date=' + anno + '-' + mese, '_blank') */
      },
      generatePDFLavorazioni (lav) {
        var lavId = typeof lav !== 'undefined' ? lav.id : ''
        var anno = this.$data.giorno.getFullYear()
        var mese = this.$data.giorno.getMonth() + 1
        if (mese < 10) {
          mese = '0' + mese
        }
        window.open('https://cortassa.ideadinamica.it/api/pdf/lavorazioni/?lav=' + lavId + '&date=' + anno + '-' + mese, '_blank')
        /* window.open('https://localhost/dinamica/cortassa/api/pdf/lavorazioni/?lav=' + lavId + '&date=' + anno + '-' + mese, '_blank') */
      }
    }
  }

</script>
<style>
.ore-lavoro-mensili{
  text-align: right;
  min-width: 80px;
  padding: 12px 16px !important;
}
.ore-lavoro-mensili-totali{
  text-align: right;
  font-weight: bold;
  padding: 12px 16px !important;
  white-space: nowrap;
}
.table-ore-lavoro-mensili th{
  text-align: center !important;
}
.ore-lavoro-mensili-paga-oraria{
  text-align: right;
  padding: 12px 16px !important;
  white-space: nowrap;
}
.riepilogo-mensile-date-picker{
  display: block;
}
.riepilogo-mensile-date-picker input {
  font-size: 1rem !important;
  line-height: 1.5;
  height: 40px;
}
.riepilogo-mensile-date-picker {
  width: 100%;
}

.table-ore-lavoro-mensili thead td:first-child,
.table-ore-lavoro-mensili tbody td:first-child,
.table-ore-lavoro-mensili thead th:first-child,
.table-ore-lavoro-mensili tbody th:first-child {
	position: sticky;
	position: -webkit-sticky;
	left: 0;
  z-index:1;
  background-color: #f7f7f7;
}

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/RiepilogoCompensi.vue